import React from "react";
import "./WelcomePage.css";
import { TagManager } from "../model/TagManager";
import { AppState } from "../model/AppState";
import { Link } from "react-router-dom";

type WelcomePageProps = {
	tagManager: TagManager;
	onDisableWelcomePage: () => void;
};

const WelcomePage: React.FunctionComponent<WelcomePageProps> = (
	props: WelcomePageProps
) => {
	let startWithSampleData = () => {
		props.tagManager.saveAppState(
			props.tagManager.createStateWithSampleData()
		);
		props.onDisableWelcomePage();
	};
	let startEmpty = () => {
		props.tagManager.saveAppState(AppState.createEmpty());
		props.onDisableWelcomePage();
	};

	return (
		<div className="WelcomePage noselect">
			<div className="Page-content w3-container">
				<h2 className="w3-center">
					<img
						src="/biglogo.svg"
						className="WelcomePage-logo"
						alt="#tagman"
					/>
				</h2>
				<h1>Welcome!</h1>
				<p>
					It looks like you're using <em>#tagman</em> for the first
					time and don't have any settings stored on this device.
				</p>
				<p>You have the choice to ...</p>
				<p>
					<button
						className="w3-button w3-border w3-border-white"
						onClick={startWithSampleData}
					>
						Start with sample data
					</button>
				</p>
				<p>... to see how it works,</p>
				<p>or to ...</p>
				<p>
					<button
						className="w3-button w3-border w3-border-white"
						onClick={startEmpty}
					>
						Start with а blank configuration
					</button>
				</p>
				<p>... because you know what you're doing :)</p>
				<p>
					<Link to="/about">Learn more about #tagman</Link>
				</p>
			</div>
		</div>
	);
};

export default WelcomePage;
